export default "__VITE_ASSET__BTOkQO_t__"